import { Link, useLocation } from 'react-router-dom';
import Dashboard from "../../assets/images/icon-dashboard.svg";
import User from "../../assets/images/icon-users.svg";
import Supportticket from "../../assets/images/menu-icon-3.svg";
import CMS from "../../assets/images/icon-review.svg";
import Faq from "../../assets/images/FAQs.svg";
import Occasion from "../../assets/images/Occasions.svg";

const VerticalMenu = () => {

    const location = useLocation();
    const isActive = (path: any) => location.pathname === path;

    return (
        <>
            <div className="layout-veritcle-menu">
                <div id="vertical_menu" className="verticle-menu">
                    <div className="menu-list">
                        <Link id="t-1" to={'/dashboard'} className="menu-item" style={{ backgroundColor: isActive('/dashboard') ? '#58CEFF' : 'transparent' }}> <img src={Dashboard} alt="icon" className="menu-icon" /> <span className='nav-text'>Dashboard</span></Link>
                        <Link id="t-1" to={'/admin-user'} className="menu-item" style={{ backgroundColor: isActive('/admin-user') ? '#58CEFF' : 'transparent' }}> <img src={User} alt="icon" className="menu-icon" /> <span className='nav-text'>Admin User</span></Link>
                        <Link id="t-1" to={'/product'} className="menu-item" style={{ backgroundColor: isActive('/product') ? '#58CEFF' : 'transparent' }}> <img src={Supportticket} alt="icon" className="menu-icon" /> <span className='nav-text'>Product</span></Link>
                        <Link id="t-1" to={'/occasions'} className="menu-item" style={{ backgroundColor: isActive('/occasions') ? '#58CEFF' : 'transparent' }}> <img src={Occasion} alt="icon" className="menu-icon" /> <span className='nav-text'>Occasions</span></Link>
                        <Link id="t-1" to={'/faq'} className="menu-item" style={{ backgroundColor: isActive('/faq') ? '#58CEFF' : 'transparent' }}> <img src={Faq} alt="icon" className="menu-icon" /> <span className='nav-text'>FAQ's</span></Link>
                        <Link id="t-1" to={'/cms'} className="menu-item" style={{ backgroundColor: isActive('/cms') ? '#58CEFF' : 'transparent' }}> <img src={CMS} alt="icon" className="menu-icon" /> <span className='nav-text'>CMS</span></Link>
                        <Link id="t-1" to={'/support-ticket'} className="menu-item" style={{ backgroundColor: isActive('/support-ticket') ? '#58CEFF' : 'transparent' }}> <img src={Supportticket} alt="icon" className="menu-icon" /> <span className='nav-text'>Support Ticket</span></Link>
                    </div>
                </div>
            </div >
        </>
    )
}

export default VerticalMenu;


